import { EXPRESSION_VARIABLES_CONSTANTS_ABBREVIATION } from '@shared/constants/calculations.constants';

export const getVariableWithNoConstantObjectBefore = (
  variable?: string,
): string | undefined =>
  variable?.startsWith(EXPRESSION_VARIABLES_CONSTANTS_ABBREVIATION)
    ? variable.slice(EXPRESSION_VARIABLES_CONSTANTS_ABBREVIATION.length)
    : variable;
